export const Auth = {
    isAdmin: () => document.cookie.match(/code=/) !== null,
};

const hostName = (function() {
    if (window.location.hostname.match(/localhost/i) !== null) {
        return 'http://localhost:1080';
    } else {
        return '';
    }
})();

const post = async function(url, data) {
    const response = await fetch(hostName + url, {
        'method': 'POST',
        'credentials': 'include',
        'headers': {
            'Content-Type': 'application/json',
        },
        'body': JSON.stringify(data)
    });
    if (response.ok) {
        return await response.json();
    } else {
        throw new Error(`Response code: ${response.status} for POST on url ${url}`);
    }
};

const get = async function(url) {
    const response = await fetch(hostName + url, {
        'method': 'GET',
        'credentials': 'include',
        'headers': {
            'Content-Type': 'application/json',
        }
    });
    if (response.ok) {
        return await response.json();
    } else {
        throw new Error(`Response code: ${response.status} for GET on url ${url}`);
    }
};

export const RestAPI = {
    get,
    post
};